import React, { useState } from 'react';
import { NavLink } from 'reactstrap';
import icon_logo from "../../../images/logo2.png";
import icon_link from "../../../images/icon-link.png";
import icon_fb2 from "../../../images/fb-2.png";
import icon_youtube2 from "../../../images/youtube-2.png";
import icon_line2 from "../../../images/line-2.png";
import icon_search from "../../../images/icon-search.png";
import icon_burger from "../../../images/burger.png";
import { Link, useNavigate } from 'react-router-dom';
import './Common_Header.css';
import { HeaderMenu, MobileMenu } from '../menu/CirculationMenu';
import scrollToAnchor from "../../package/scrollToAnchor";
import apiService from "../../api/apiService";

/**
 * 表頭-公用
 * */
function Common_Header(porp) {
    const [searchname, setSearchname] = useState('');
    const navigate = useNavigate();
    const [mode, setMode] = useState('wait');
    const [data, setData] = useState([]);

    const search_handle = function () {

        navigate("/Search/" + searchname);
    }

    if (mode == 'wait') {
        //載入熱門關鍵字
        apiService.HotKeyword.get_HotKeyword('', 'tw', function (rs_data) {
            setMode('ok');
            if (rs_data.data.length > 2) {
                setData(JSON.parse(rs_data.data));
            } else {
                setData([]);
            }
        });
    }
    else {
        var html_data = [];
        data.map((item, index) => {
            html_data.push(<option key={index} value={item.HkdKeyword}></option>);
        });
    }

    return (<header className="container-xxl">
        <div className="desktop">
            <div className="displayBox">


                <datalist id="listData">
                    {html_data}
                </datalist>

                <div className="left">

                    <a id="top" role="button" onClick={(x) => scrollToAnchor('top')} title="上方導覽連結區" className="left text-right alinkclearTop" accessKey="U">:::</a>
                        <Link to="/" role="button" className="alinkclear flex_a_j_c" title="資源循環網">
                            <img src={icon_logo} alt="資源循環網 logo" />
                        </Link>
                </div>
                <div className="right">
                    <div className="top">
                        <div className="cp"><Link title="首頁" to="/">首頁</Link></div>
                        <div className="cp">
                            <Link title="網站導覽" to="/sitemap">網站導覽</Link>
                        </div>
                        <div className="cp d-none">
                            <Link title="最新消息" to="/news">最新消息</Link>
                        </div>

                        <div className="cp">
                            <Link title="English" to="/en">English</Link>
                        </div>
                        <div className="cp">
                            <a title="環境部(另開視窗)" rel="noopener noreferrer" target="_blank" href="https://www.moenv.gov.tw">環境部</a>
                        </div>

                        <div className="outsideLink">
                            <div className="dropdown">
                                <img src={icon_link} alt="icon_link" id="dropdownMenuButton1"
                                    data-bs-toggle="dropdown" aria-expanded="false" />
                                <div className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                    <div><img role="button" onClick={(x) => window.open('https://www.facebook.com/MOENV.TW/')}
                                        src={icon_fb2} title="FaceBook(另開視窗)" alt="facebook" /></div>
                                    <div><img role="button" onClick={(x) => window.open('https://www.youtube.com/@TaiwanEpaTW') }
                                        src={icon_youtube2} title="Youtube(另開視窗)" alt="youtube" /></div>
                                    <div><img role="button" onClick={(x) => window.open('https:\/\/line.me/R/ti/p/KjOox0U09B') }
                                        src={icon_line2} title="Line(另開視窗)" alt="line" /></div>
                                </div>
                            </div>
                        </div>
                        <div className="search">

                            <input type="text" list="listData" onChange={(x) => setSearchname(x.target.value)} name="q" accessKey="S" placeholder="請輸入關鍵字..." title="請輸入關鍵字" form="searchForm" autoComplete="off" />
                            <button type="submit" className="master_search" onClick={search_handle} value="送出" form="searchForm"> <img src={icon_search} title="查詢關鍵字" alt="查詢關鍵字" /></button>
                        </div >
                    </div >
                    <div className="bottom">

                        <HeaderMenu />
                    </div>
                </div>
            </div>
        </div>
        <div className="mobile">
            <div className="displayBox">

                <img className="toggle" type="button" data-bs-toggle="collapse"
                    data-bs-target="#navbarToggleExternalContent" src={icon_burger} alt="menu" />

                <Link to="/index" className="logo alinkclear flex_a_j_c" title="資源循環網">
                    <img src={icon_logo} alt="資源循環網 logo" />
                </Link>

                <div className="collapse" id="navbarToggleExternalContent">
                    <div className="accordion" id="accordionExample">
                        <MobileMenu />

                    </div>
                </div>
            </div>
        </div>
    </header>);

}

export default Common_Header;